import { $closest } from 'fxdom/es';
import { go } from 'fxjs/es';
import axios from 'axios';

export const setTextAlign = async ({ el, text_align, device_type }) => {
  const dc_data = go(el, $closest('.design_collection_content'), box.sel);
  dc_data['text_align' + device_type] = text_align;
  await axios.post('/@api/collaboration/update_design_collection_contents', [dc_data]);
};
